var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizzesAss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3281 35.1426V44.6933",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2266 14.6201C19.2266 13.6756 19.5066 12.7523 20.0314 11.967C20.5561 11.1817 21.3019 10.5697 22.1745 10.2082C23.047 9.84679 24.0072 9.75224 24.9336 9.93647C25.8599 10.1207 26.7108 10.5755 27.3786 11.2434C28.0465 11.9112 28.5013 12.7621 28.6855 13.6885C28.8698 14.6148 28.7752 15.575 28.4138 16.4475C28.0523 17.3201 27.4403 18.0659 26.655 18.5907C25.8697 19.1154 24.9464 19.3954 24.0019 19.3954V20.9872",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0029 27.5532C23.5634 27.5532 23.207 27.1969 23.207 26.7573C23.207 26.3178 23.5634 25.9614 24.0029 25.9614",
    stroke: "#EA7F4A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0039 27.5532C24.4435 27.5532 24.7998 27.1969 24.7998 26.7573C24.7998 26.3178 24.4435 25.9614 24.0039 25.9614",
    stroke: "#EA7F4A",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5115 44.6931H11.2675C10.0011 44.6931 8.7864 44.1901 7.89086 43.2945C6.99532 42.399 6.49219 41.1841 6.49219 39.9177C6.49219 38.6513 6.99532 37.4364 7.89086 36.5409C8.7864 35.6454 10.0011 35.1424 11.2675 35.1424H38.3279C39.1722 35.1424 39.9821 34.8068 40.579 34.2099C41.1759 33.613 41.5115 32.8031 41.5115 31.9588V6.49021C41.5115 5.64587 41.1759 4.83612 40.579 4.23909C39.9821 3.64205 39.1722 3.30664 38.3279 3.30664H11.2675C10.0228 3.3062 8.82708 3.7918 7.93511 4.65999C7.0431 5.5282 6.52539 6.71036 6.49219 7.95466V39.7904",
    stroke: "#215250",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizzesAss);
export default __webpack_public_path__ + "static/media/quizzes-ass.303c3c2799944e37a41807bb48f7359b.svg";
export { ForwardRef as ReactComponent };